
import { PropType, defineComponent, watch } from "vue";
import { Modal } from "bootstrap";
export default defineComponent({
  name: "ModalRecoverRegister",
  props: {
    message: {
      type: String,
      default: "O registro selecionado será recuperado."
    },
    header: {
      type: String,
      default: "Recuperar registro!"
    },
    name: {
      type: String,
      default: "Registro"
    },
    toggle: {
      type: Boolean,
      default: false
    },
    handleButtonClick: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
  setup(props, { emit }) {
    // Variables
    let auxModal

    // Functions
    const openModal = (id: string) => {
      const auxElement = document.querySelector(`#${id}`);
      auxModal = new Modal(auxElement);
      auxModal.show();
    }

    // Life Cycles
    watch(() => props.toggle, () => openModal("ModalRecoverRegister"))

    return { }
  }
})
